import _ from 'lodash';

import { ChartSettingsT, VizType } from 'business/definitions';
import { disableChartConception } from 'helpers/features';
import { flow } from 'fp-ts/function';
import {
    chartConceptionFormatVizPipeline,
    initialFormatVizPipeline,
} from './pipeline';
import { FormatedChart, UnformatedChart } from './types';
import { getIsChartConceptionEnabled } from './conception';

export type FormatVizDataArgs = {
    vizType: VizType;
    data: ResponseDataT[];
    columns: ResponseColumnT[];
    queryMetrics: QueryMetricT[];
    settings: ChartSettingsT;
};

// TODO: split and write tests for this
export function formatVizData({
    data,
    columns,
    settings,
    vizType,
    queryMetrics,
}: FormatVizDataArgs): FormatedChart {
    // NOTE: for chartData, we need to take into account the fact that values can be of the form:
    // { value, label }. In this case we need to unpack the label.

    const unformattedDict: UnformatedChart = {
        chartColumns: _.cloneDeep(columns).map((col) => ({
            ...col,
        })),
        // @ts-expect-error idk how to type this
        chartData: _.cloneDeep(data).map((point) =>
            _.mapValues(point, (val) => (val === null ? '' : val)),
        ),
    };
    const isChartConceptionEnabled =
        getIsChartConceptionEnabled(settings, columns, vizType) &&
        !disableChartConception;
    const formatVizDataFlow = isChartConceptionEnabled
        ? flow(...chartConceptionFormatVizPipeline)
        : flow(...initialFormatVizPipeline);

    const { chartColumns, chartData } = formatVizDataFlow({
        chartData: unformattedDict.chartData,
        chartColumns: unformattedDict.chartColumns,
        context: {
            settings,
            vizType,
            queryMetrics,
        },
    });
    return { chartData, chartColumns };
}
